import { useRef } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'

import { handleMapTypeIdChange, jsApiLoaderOptions } from 'src/constants'
import { useStyles } from '../styles'

interface IProps {
  center: {
    lat: number
    lng: number
  }
}

export const ScanMap = ({ center }: IProps) => {
  const mapRef = useRef<google.maps.Map | null>(null)

  const classes = useStyles()

  const handleLoad = (map: google.maps.Map) => {
    mapRef.current = map
    handleMapTypeIdChange(map)
  }

  const { isLoaded } = useJsApiLoader(jsApiLoaderOptions)
  return isLoaded ? (
    <GoogleMap
      mapContainerClassName={classes.map}
      center={center}
      options={{ streetViewControl: false, fullscreenControl: false }}
      zoom={14}
      onLoad={handleLoad}
      onMapTypeIdChanged={() => {
        handleMapTypeIdChange(mapRef?.current)
      }}
    >
      <Marker position={center} />
    </GoogleMap>
  ) : (
    <></>
  )
}
